import { ElNotification } from 'element-plus';

type Position = 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';

function notifyWarning(message: string, position?: Position) {
  ElNotification({
    title: '警告',
    message,
    type: 'warning',
    position: position || 'top-right',
  });
}

export default notifyWarning;
